export const GET_FAVOURITE_LOADING = "GET_FAVOURITE_LOADING";
export const GET_FAVOURITE_SUCCESS = "GET_FAVOURITE_SUCCESS";
export const GET_FAVOURITE_ERROR = "GET_FAVOURITE_ERROR";
export const REMOVE_FAVOURITE = "REMOVE_FAVOURITE";